export default {
    SAVE_LOV_CODES     : "SAVE_LOV_CODES",
    SAVE_LOV_CONSTANTS : "SAVE_LOV_CONSTANTS",
    SAVE_VEHICLE_TYPES : "SAVE_VEHICLE_TYPES"
}